import { getUserList, addUser, removeUser, updateUserRole }  from 'Api/companyApi'
import { parseUser }  from 'Parsers/companyUserParser'

const state = {
  requesting: {
    userList: false,
    addUser: false,
    removeUser: false,
    updateUserRole: false,
  },

  pagination: {
    current: 1,
    limit: 1,
  },

  searchTerm: '',

  userList: [],
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },
  request_success(state, type) {
    state.requesting[type] = false
  },
  request_failure(state, type) {
    state.requesting[type] = false
  },
  set_user_list(state, userList) {
    const processedUserList = userList.map(user => {
      if (user.id === null) {
        return {
          ...user,
          __tempId: 'pending-' + Math.random().toString(36).substring(2, 15) + Date.now(),
        };
      }
      return user
    })
    state.userList = processedUserList;
  },
  set_pagination(state, pagination) {
    state.pagination = pagination
  },
  set_search_term(state, searchTerm) {
    state.searchTerm = searchTerm
  },
  set_search_sort(state, searchSort) {
    state.searchSort = searchSort
  },
}

const actions = {
  async getUserList({ commit }) {
    const { searchTerm, pagination } = state
    commit('request_start', 'userList')

    try {
      let options = {}

      if (searchTerm !== '') {
        options.filter = searchTerm
      }

      const { data } = await getUserList(pagination.current, options)

      const userList = data.items.map(parseUser)
      commit('set_user_list', userList)
      commit('set_pagination', { current: data.page, limit: data.pageCount })

      commit('request_success', 'userList')

      return userList
    } catch (err) {
      commit('request_failure', 'userList')

      throw err
    }
  },

  async searchUser({ commit, dispatch }, query) {
    commit('set_search_term', query)

    try {
      const result = await dispatch('getUserList')

      return result
    } catch (err) {
      throw err
    }
  },

  async paginate({ state, commit, dispatch }, page) {
    const { pagination } = state
    commit('set_pagination', Object.assign({}, pagination, { current: page }))

    try {
      const result = await dispatch('getUserList')

      return result
    } catch (err) {
      throw err
    }
  },

  async addUser({ commit }, info) {
    commit('request_start', 'addUser')

    try {
      const { name, email, role, ddd, phone } = info
      const result = await addUser({ name, email, role, ddd, phone })

      commit('request_success', 'addUser')

      return result
    } catch (err) {
      commit('request_failure', 'addUser')

      throw err
    }
  },

  async removeUser({ commit }, email) {
    commit('request_start', 'removeUser')

    try {
      const result = await removeUser(email)

      commit('request_success', 'removeUser')

      return result
    } catch (err) {
      commit('request_failure', 'removeUser')

      throw err
    }
  },

  async updateUserRole({ commit }, { email, role }) {
    commit('request_start', 'updateUserRole')

    try {
      const result = await updateUserRole(email, role)

      commit('request_success', 'updateUserRole')

      return result
    } catch (err) {
      commit('request_failure', 'updateUserRole')

      throw err
    }
  }
}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}